import { AVRProducts } from '@/utils/enums';

export default store => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'vehicle/SET_VEHICLE_INFO' && !!mutation.payload) {
      const { products } = state.business.info;

      // Insurance is enabled?
      if (products.includes(AVRProducts.INSURANCE)) {
        // Set an insurance vehicle data from vin decoder.
        store.commit('insurance/SET_INSURANCE_VEHICLE', mutation.payload);
      }
    }
  });
};
